import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faDesktop, 
  faCalendarAlt, 
  faUserGraduate, 
  faCheckCircle,
  faChalkboardTeacher,
  faAward,
  faLaptopCode,
  faSmile
} from '@fortawesome/free-solid-svg-icons';
import CountUp from 'react-countup'; // Replacing PureCounter with a more React-friendly solution
import VisibilitySensor from 'react-visibility-sensor'; // For triggering animations when visible
import './FunFactArea.css';
const FunFactArea = () => {
  const [funFacts, setFunFacts] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/class-stats`);
        const data = await response.json();
        
        setFunFacts([
          { 
            end: data.demoClasses, 
            suffix: '+', 
            label: 'Demo Classes', 
            icon: faDesktop,
            color: 'var(--primary)',
            duration: 2
          },
          { 
            end: data.scheduledClasses, 
            suffix: '+', 
            label: 'Scheduled Classes', 
            icon: faCalendarAlt,
            color: 'var(--secondary)',
            duration: 2.5
          },
          { 
            end: data.studentsEnrolled, 
            suffix: '+', 
            label: 'Students Enrolled', 
            icon: faUserGraduate,
            color: 'var(--accent)',
            duration: 3
          },
          { 
            end: data.classesCompleted, 
            suffix: '+', 
            label: 'Classes Completed', 
            icon: faCheckCircle,
            color: 'var(--success)',
            duration: 2.2
          },
        ]);
      } catch (error) {
        console.error('Error fetching fun facts:', error);
        // Fallback data if API fails
        setFunFacts([
          { end: 125, suffix: '+', label: 'Demo Classes', icon: faDesktop, color: '#4e73df', duration: 2 },
          { end: 342, suffix: '+', label: 'Scheduled Classes', icon: faCalendarAlt, color: '#1cc88a', duration: 2.5 },
          { end: 856, suffix: '+', label: 'Students Enrolled', icon: faUserGraduate, color: '#36b9cc', duration: 3 },
          { end: 512, suffix: '+', label: 'Classes Completed', icon: faCheckCircle, color: '#f6c23e', duration: 2.2 },
        ]);
      }
    };

    fetchStats();
  }, []);

  return (
    <VisibilitySensor 
      onChange={(visible) => visible && setIsVisible(true)}
      partialVisibility
      offset={{ bottom: 200 }}
    >
      <section className="funfact-area">
        <div className="funfact-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">Our Impact in Numbers</h2>
            <p className="section-subtitle">See how we're making a difference in education</p>
          </div>
          
          <div className="funfact-grid">
            {funFacts.map((item, index) => (
              <div className="funfact-card" key={index}>
                <div className="funfact-icon" style={{ color: item.color }}>
                  <FontAwesomeIcon icon={item.icon} />
                </div>
                <div className="funfact-content">
                  <h3 className="funfact-number">
                    {isVisible && (
                      <CountUp
                        end={item.end}
                        duration={item.duration}
                        separator=","
                        suffix={item.suffix}
                      />
                    )}
                  </h3>
                  <p className="funfact-label">{item.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </VisibilitySensor>
  );
};

export default FunFactArea;